import React, { useState } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import {
  filtersState,
  groupsState,
  previewLastSelected,
  previewState
} from '../recoil/state/preview'
import deviceSizes from 'Components/PreviewTool/support/deviceSizes'
import PreviewTools, {
  Tabs,
  TabsDesktopOrMobile,
  TabShowDynamicContent
} from 'Components/PreviewTool'
import {
  searchRecipientsCallback,
  updatePreviewCallback
} from '../recoil/callbacks/callbacks'

import { SpacingVertical, SPACING_24, SPACING_40 } from 'mailup-web-components'
import styled from '@emotion/styled'
import SelectRecipient from 'Components/PreviewTool/SelectRecipient'

const Preview = () => {
  const [deviceType, setDeviceType] = useState('desktop')
  const [sizeId, setSizeId] = useState(deviceSizes[0].id)
  const {
    lastEmails,
    lastFilters,
    lastGroups,
    previewReferenceRecipient
  } = useRecoilValue(previewLastSelected)
  const { options, optionGroups } = useRecoilValue(filtersState)
  const groups = useRecoilValue(groupsState)
  const searchRecipients = useRecoilCallback(searchRecipientsCallback, [
    previewReferenceRecipient
  ])

  const {
    html,
    showPersonalization,
    dynamicContents,
    loading,
    error,
    selectedDynamicContents
  } = useRecoilValue(previewState)

  const handleConfirmDynamicContents = useRecoilCallback(
    updatePreviewCallback,
    []
  )

  const size = deviceSizes.find(size => size.id === sizeId)

  const TabsComponent = () => (
    <Tabs>
      <TabsDesktopOrMobile
        active={deviceType}
        onClickTab={value => setDeviceType(value)}
        onChangeSelect={value => setSizeId(value)}
        selectValue={sizeId}
        showMobile
      />
      {dynamicContents && dynamicContents.length > 0 && (
        <TabShowDynamicContent
          onConfirm={handleConfirmDynamicContents}
          items={dynamicContents}
          initialValues={selectedDynamicContents}
        />
      )}
    </Tabs>
  )

  return (
    <div className='t-message-edit__content'>
      <PreviewTools
        TabsComponent={TabsComponent}
        content={html}
        loading={loading}
        error={error}
        previewers={
          showPersonalization
            ? undefined
            : [
                {
                  sandbox:
                    'allow-same-origin allow-popups allow-popups-to-escape-sandbox',
                  content: html,
                  active: deviceType === 'desktop'
                },
                {
                  sandbox:
                    'allow-same-origin allow-popups allow-popups-to-escape-sandbox',
                  content: html,
                  width: size.width,
                  height: size.height,
                  pixelRatio: size.pixelRatio,
                  active: deviceType === 'mobile'
                }
              ]
        }
      >
        <StyledSection showPersonalization={showPersonalization}>
          <SpacingVertical variant={SPACING_40} />
          <SpacingVertical variant={SPACING_24} />
          <SelectRecipient
            groups={groups}
            filters={options}
            filterGroups={optionGroups}
            lastEmails={lastEmails}
            lastFilters={lastFilters}
            lastGroups={lastGroups}
            lastTypeSelected={previewReferenceRecipient.lastTypeSelected}
            searchRecipientsCallback={searchRecipients}
          />
        </StyledSection>
      </PreviewTools>
    </div>
  )
}

export default Preview

const StyledSection = styled.div`
  position: relative;
  background-color: var(--wild-sand);

  ${({ showPersonalization }) => !showPersonalization && 'display: none'}
`
